{
    "Accessibility Menu": "Menu di accessibilità",
    "Reset settings": "Ripristina impostazioni",
    "Close": "Chiudi",
    "Content Adjustments": "Regolazioni del contenuto",
    "Adjust Font Size": "Regola la dimensione del carattere",
    "Highlight Title": "Evidenzia il titolo",
    "Highlight Links": "Evidenzia i collegamenti",
    "Readable Font": "Carattere leggibile",
    "Color Adjustments": "Regolazioni del colore",
    "Dark Contrast": "Contrasto scuro",
    "Light Contrast": "Contrasto chiaro",
    "High Contrast": "Alto contrasto",
    "High Saturation": "Alta saturazione",
    "Low Saturation": "Bassa saturazione",
    "Monochrome": "Monocromatico",
    "Tools": "Strumenti",
    "Reading Guide": "Guida alla lettura",
    "Stop Animations": "Arresta le animazioni",
    "Big Cursor": "Cursore grande",
    "Increase Font Size": "Aumenta la dimensione del carattere",
    "Decrease Font Size": "Diminuisci la dimensione del carattere",
    "Letter Spacing": "Spaziatura delle lettere",
    "Line Height": "Altezza della linea",
    "Font Weight": "Peso del carattere",
    "Dyslexia Font": "Carattere per dislessia",
    "Language": "Lingua",
    "Open Accessibility Menu": "Apri il menu di accessibilità"
}